/* 常量 */

// 组委id
export const MAIN_TENANT_ID = 1;

// 租户本地缓存
export const TENANT_STORAGE_KEY = 'bylTenantInput';
